import React from "react";
import { useParams } from "react-router-dom";
import { apiCallPost, indianRupee, niceDateTime } from "../util/util";
import "../Prescription.css";

import { ControlGroup, NonIdealState, Spinner, Tag } from "@blueprintjs/core";
import _ from "lodash";
import cogoToast from "cogo-toast";

function withRouter(Component) {
  function ComponentWithRouter(props) {
    let params = useParams();
    return <Component {...props} params={params} />;
  }
  return ComponentWithRouter;
}

class CashTillLowerOrder extends React.Component {
  state = { isLoading: true, isFailure: false, res: null };
  componentDidMount() {
    let ss = this.props.params.cashTillId;
    if (ss) {
      this.getSubmission(ss);
    } else {
      this.setState({ isLoading: false, isInvalid: true });
    }
  }
  getSubmission = async (ss) => {
    try {
      let res = await apiCallPost("/print/cashtill", {
        cashTillId: ss,
      });
      this.setState({ isLoading: false, till: res.till });
    } catch (err) {
      cogoToast.error("Failed to load cash till data.");
      this.setState({ isLoading: false, isFailure: true });
    }
  };

  renderTill = () => {
    if (!this.state.till) {
      return null;
    }
    return (
      <div>
        <ControlGroup>
          <Tag large minimal>
            User
          </Tag>
          <Tag large minimal className="bg__none">
            {this.state.till.createdBy}
          </Tag>{" "}
          <Tag large minimal>
            Site
          </Tag>
          <Tag large minimal className="bg__none">
            {this.state.till.site}
          </Tag>
          <Tag large minimal>
            Last Updated
          </Tag>
          <Tag large minimal className="bg__none">
            {niceDateTime(this.state.till.updatedAt)}
          </Tag>
        </ControlGroup>
        <ControlGroup>
          <Tag minimal className="bg__none font__x__small">
            {this.state.till._id}
          </Tag>
        </ControlGroup>
        <hr />
        {this.renderEachDenom("2000")}
        {this.renderEachDenom("500")}
        {this.renderEachDenom("200")}
        {this.renderEachDenom("100")}
        {this.renderEachDenom("50")}
        {this.renderEachDenom("20")}
        {this.renderEachDenom("10")}
        {this.renderEachDenom("5")}
        {this.renderEachDenom("2")}
        {this.renderEachDenom("1")}
        <br />
        <br />
        {this.renderCheck()}
      </div>
    );
  };
  renderCheck = () => {
    let sum = 0;
    for (var i = 0; i < this.state.till.cash.length; i++) {
      sum = parseInt(
        sum +
          Number(this.state.till.cash[i].denom) * this.state.till.cash[i].count
      );
    }

    return (
      <ControlGroup vertical>
        <ControlGroup>
          <Tag minimal large>
            Total Entered
          </Tag>
          <Tag minimal large className="bg__none">
            {indianRupee(sum, 0, false)}
          </Tag>
        </ControlGroup>
      </ControlGroup>
    );
  };
  renderEachDenom = (denom) => {
    let whichDenomIdx = _.findIndex(
      this.state.till.cash,
      (each) => each.denom === denom
    );
    let whichDenom = this.state.till.cash[whichDenomIdx];
    return (
      <ControlGroup style={{ marginTop: "5px" }}>
        <Tag minimal large style={{ width: "6em" }} className="bg__none">
          {indianRupee(whichDenom.denom, 0, false)}
        </Tag>{" "}
        <Tag minimal large>
          {" "}
          x{" "}
        </Tag>{" "}
        <Tag minimal large className="bg__none">
          {" "}
          {whichDenom.count}
        </Tag>
        <Tag minimal large>
          {" "}
          ={" "}
        </Tag>
        <Tag minimal large className="bg__none">
          {indianRupee(Number(whichDenom.denom) * whichDenom.count, 0, false)}
        </Tag>
      </ControlGroup>
    );
  };
  render() {
    if (this.state.isLoading) {
      return (
        <div className="center_screen">
          <NonIdealState icon={<Spinner />} title="Loading..." />
        </div>
      );
    }
    if (this.state.isFailure) {
      return (
        <div className="center_screen">
          <NonIdealState
            icon="warning-sign"
            title="We ran into an error. If you face this problem multiple times, please contact support."
          />
        </div>
      );
    }
    return <div style={{ margin: "30px" }}>{this.renderTill()}</div>;
  }
}

const CashTill = withRouter(CashTillLowerOrder);
export default CashTill;
